export function constructQueryString(params: Record<string, string>): string {
  return Object.entries(params)
    .filter(([key, value]) => key && value)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}

export function constructQueryStringWithRepeatedKeys(params: Record<string, string[]>): string {
  return Object.entries(params)
    .flatMap(([key, values]) => values.map((value) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`))
    .join('&');
}
